import { useState, useEffect } from 'react';
import { ReactComponent as CalendarIcon } from '~/assets/svg/calendar.svg';
import { useTranslation } from 'react-i18next';

const ScheduleConfirmationScreen = () => {
  const [selectedMeetingType, setSelectedMeetingType] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [t] = useTranslation('calendar');

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const meetingModes = [t('virtual'), t('in_person')];
  const locations = [''];

  const isButtonEnabled =
    selectedMeetingType === t('virtual') ||
    (selectedMeetingType === t('in_person') && selectedLocation);

  return (
    <div className="flex min-h-screen bg-base-100">
      {/* Panel izquierdo */}
      <div className="w-full p-8 md:w-1/2">
        <button
          onClick={() => window.history.back()}
          className="btn btn-ghost btn-sm mb-6"
        >
          ← {t('back')}
        </button>
        <div className="card-brand">
          <div className="card-body">
            <h1 className="text-brand-heading text-3xl mb-4">
              {t('confirmation_title', 'Confirmación de Cita')}
            </h1>
            <p className="text-brand-body">
              {t('confirmation_message', 'Tu cita ha sido confirmada exitosamente.')}
            </p>
          </div>
        </div>
      </div>

      {/* Panel derecho */}
      {isDesktop && (
        <div className="hidden md:flex w-1/2 items-center justify-center bg-brand-gradient rounded-r-xl">
          <div className="text-center">
            <CalendarIcon className="w-64 h-64 text-white opacity-80 mx-auto mb-4" />
            <h3 className="text-brand-heading text-white text-2xl">
              {t('success_title', '¡Cita Confirmada!')}
            </h3>
            <p className="text-white/80 mt-2 text-lg">
              {t('success_subtitle', 'Recibirás una confirmación por email')}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScheduleConfirmationScreen;
